import { IAppState } from '../../redux';
import { EServiceId, IBetPosition } from '../../redux/reducers';

export const selectTopAuctionBetPosition = (state: IAppState): IBetPosition | null => {
  const {
    betPosition: { positionByService },
  } = state;

  return positionByService[EServiceId.paid] || positionByService[EServiceId.free] || null;
};
